export default __webpack_public_path__ + "static/media/vercel.fd5f44a4.svg";